import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import { trackEvent } from "@/utils/tagManagerUtils";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const AutomazioneGoogleAdsIT = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    trackEvent("page_view", { path: "/it/automazione-google-ads" });
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <title>Strumento di Automazione Google Ads | Upfixe</title>
        <meta
          name="description"
          content="Upfixe è lo strumento di automazione Google Ads definitivo. Risparmia ore di lavoro manuale e lascia che l'IA ottimizzi le tue campagne PPC."
        />
        <meta
          name="keywords"
          content="automazione google ads, strumento google ads, ia google ads, ottimizzazione ppc"
        />
        <link rel="canonical" href="https://upfixe.com/it/automazione-google-ads" />
      </Helmet>

      <Header />

      <main className="flex-grow pt-24 pb-16">
        <section className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto text-center mb-20">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-gray-900 mb-6">
            Lo strumento di automazione <span className="text-primary">Google Ads più intelligente</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-10">
            Smetti di perdere ore nella ricerca manuale di parole chiave e aggiustamenti delle offerte.
            Upfixe automatizza l'intero flusso di lavoro di Google Ads.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Button asChild size="lg" className="text-lg px-8 py-6 rounded-full">
              <a href="https://app.upfixe.com/signup">
                Prova Gratuita <ArrowRight className="ml-2 h-5 w-5" />
              </a>
            </Button>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default AutomazioneGoogleAdsIT;
